<template>
    <div>
			<!--面包屑导航区域-->
            <div class="crumbs">
            	<el-breadcrumb separator="/">
				<el-breadcrumb-item>
              <i class="el-icon-school"></i> 绘本开放幼儿园
			  </el-breadcrumb-item>
            </el-breadcrumb>
		</div>
		<div class="container">
			<el-form :model="query" ref="query" >
				<div class="handle-box">
					<el-row>
						<el-col :span="22">
							<div class="grid-content bg-purple">
								<!--搜索与添加-->
								<el-input v-model="query.name" clearable :placeholder="'请输入幼儿园名称'" class="handle-input mr10" style="width: 15%;"></el-input>
								<el-select  v-model="query.hbop" clearable :placeholder="'请选择借阅方式'" class="select-shop mr10">
									<el-option v-for="item in query.optionsHbop" :key="item.INIKEY2" :label="item.INIDISP" :value="item.INIKEY2"></el-option>
								</el-select>
								
								<!-- <el-select v-model="query.stat" clearable :placeholder="'请选择删除状态'" class="select-shop mr10">
									<el-option v-for="item in query.optionsStat" :key="item.INIKEY2" :label="item.INIDISP" :value="item.INIKEY2"></el-option>
								</el-select> -->
							</div>
						</el-col>
						<el-col :span="2">
							<div class="grid-content bg-purple-light">
								<el-button  type="warning" :disabled="!hasPerms(buttonPerms.searchPerms)" class="float" icon="el-icon-search"@click="handleSearch">搜索</el-button>
							</div>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="22">
							<div class="grid-content bg-purple">
								<!-- <el-button type="success" :disabled="!hasPerms(buttonPerms.batchrelationPerms)" icon="el-icon-connection" @click="delAllRelation">批量关联</el-button> -->
							</div>
						</el-col>
						<el-col :span="2" style="text-align: right;">
								<el-button type="primary" :disabled="!hasPerms(buttonPerms.addPerms)" icon="el-icon-plus" @click="handleAdd">添加开放园</el-button>
						</el-col>
					</el-row>
				</div>

				<el-table :data="tableData" border class="table" 
				 header-cell-class-name="table-header" :row-key="getRowKeys" v-loading="loading">
					<el-table-column type="index" :label="'序号'" width="80" align="center"></el-table-column>
					<el-table-column prop="SAANAME" :label="'幼儿园名称'"align="center" ></el-table-column>
					<el-table-column prop="SAAHBOP" :label="'借阅方式'" align="center"></el-table-column>
					<el-table-column prop="SAAJYSL" :label="'可借阅数量'" align="center"></el-table-column>
					<el-table-column prop="SAAKJSJ" :label="'借阅天数'" align="center"></el-table-column>

					
					<el-table-column :label="'操作'" width="200" align="center" class="without-outline">
						<template slot-scope="scope">
							<el-button type="text" :disabled="!hasPerms(buttonPerms.editPerms)" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
							<el-button type="text" :disabled="!hasPerms(buttonPerms.editHBFYPerms)"  icon="el-icon-edit" @click="handleEditYCJE(scope.$index, scope.row)">费用设置</el-button>
						</template>
					</el-table-column>
				</el-table>
				
				
				<div class="pagination">
					<el-pagination background layout="total, prev, pager, next, jumper,sizes" :current-page="this.query.pageIndex"
					:page-sizes="[10, 50,100]" :page-size="this.query.pageSize" :total="this.pageTotal" @size-change="handleSizeChange" @current-change="handlePageChange"></el-pagination>
				</div>
			</el-form>
		</div>
    </div>
</template>

<script>
	import {
			hasPermission
		} from '@/permission/index.js'
		export default {
			name: 'bookSAA',
			inject: ['reload'], //在子组件中通过inject调用
			data() {
				return {
					//页面按钮权限
					buttonPerms: {
						addPerms: 'book:bookSAA:add', //新增权限标识
						searchPerms: 'book:bookSAA:search', //搜索权限标识
						editPerms: 'book:bookSAA:edit', //编辑权限标识
						// editYCJEPerms: 'garden:gardenList:editYCJE', //编辑权限标识
						deletePerms: 'book:bookSAA:delete', //删除权限标识
						batchdelPerms: 'book:bookSAA:batchdel', //批量删除权限标识
						batchrelationPerms: 'book:bookSAA:batchrelation', //批量删除权限标识
						editHBFYPerms:'book:bookSAA:editHBFY',
						disabled: false
					},
					
					web_suuid: sessionStorage.getItem("ms_web_suuid"), 
					web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户
					roleFlag:false,
					page:1,
					
					arrList: [],
					query: {
						optionsHbop: '',
						name: '',
						hbop: '',
						pageIndex: 1, //当前页
						pageSize: 10 //这是当前每页显示的条数
					},
					tableData: [],
					
					multipleSelection: [], // 多选操作
					delList: [],
					pageTotal: 0, // 总条数
					loading: false,
				};
			},
			created() {
				if(sessionStorage.getItem('bookSAApage')!=null)
				{
					this.query.pageIndex=Number(sessionStorage.getItem('bookSAApage'))
				}
				let curpagenum = this.query.pageIndex; //当前页码
				this.getData(curpagenum); //获取当前列表数据
				this.get_SAA_List_Count(); //获取当前列表条数
				this.getINI();
			},
			
			watch: {
				$route(to, from) {
					if (to.name === "bookSAA") {
						
						if(sessionStorage.getItem('bookSAApage')!=null)
						{
							this.query.pageIndex=Number(sessionStorage.getItem('bookSAApage'))
						}
						
						this.get_SAA_List_Count()
						this.getData( this.query.pageIndex )
					}
				}
			},
			
			
			mounted() {
				this.$bus.$on('change', () => {
					//刷新当前页面
					// this.reload();
				})
			},
			destroyed(){
				console.log('销毁')
				sessionStorage.removeItem('bookSAApage')
			},
			methods:{
				
				hasPerms: function(perms) {
					// 根据权限标识和外部指示状态进行权限判断
					return hasPermission(perms) & !this.buttonPerms.disabled
				},
				// 获取当前列表条数
				get_SAA_List_Count() {
					const self_count = this;
					var postUrl = 'WCF/WEB/svcSMA.svc/Get_SAA_List_Count';
					//网络请求接口
					this.$axios.post(
							//请求的url
							postUrl,
							//请求参数
							{
								sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
								sNAME: self_count.query.name,
								sHBOP: self_count.query.hbop,
							}
						)
						.then((response) => {
							//请求成功返回的数据
							let resCount = response.data.KKDTCOUNT;
							this.pageTotal = Number(resCount); //总条数
						})
						.catch((error) => {
							this.$message({
								message: '获取信息失败', //请求失败
								type: 'error'
							});
						});
				},
				// 获取幼儿园数据
				getData(curpage) {
					this.loading = true; //初始化加载loading效果
					const self_count = this;
					var postUrl = 'WCF/WEB/svcSMA.svc/Get_SAA_List';
					//网络请求接口
					this.$axios.post(
							//请求的url
							postUrl,
							//请求参数
							{
								sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
								sNAME: self_count.query.name,
								sHBOP: self_count.query.hbop,
								sPageIndex: curpage, //页码
								sPageSize: self_count.query.pageSize //每页显示条数
						
							})
						.then((response) => {
							this.loading = false; //取消loading效果
							//请求成功返回的数据
							let resCount = response.data.KKDTCOUNT;
							//console.log(resCount);
							let resKKDT = response.data.KKDT;
							//console.log(resKKDT);
							if (resCount > 0) {
								
								//渲染数据 List
								this.tableData = resKKDT; //数据数组
							} else {
								this.tableData = []; //数据数组
							}
						})
						.catch((error) => {
							this.loading = false; //取消loading效果
							this.$message({
								message: '获取信息失败', //请求失败
								type: 'error'
							});
						});
				
				},
				
				getINI() {
					const self_count = this;
					var postUrl = 'WCF/Public/svcPublic.svc/Get_INI_KEY1';
					//网络请求接口
					this.$axios.post(
							//请求的url
							postUrl,
							//请求参数
							{
								sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
								sKEY1:'10021'
							})
						.then((response) => {
							
							//请求成功返回的数据
							let resCount = response.data.KKDTCOUNT;
							//console.log(resCount);
							let resKKDT = response.data.KKDT;
							//console.log(resKKDT);
							if (resCount > 0) {
								
								//渲染数据 List
								this.query.optionsHbop = resKKDT; //数据数组
							} else {
								this.query.optionsHbop = []; //数据数组
							}
						})
						.catch((error) => {
							this.$message({
								message: '获取信息失败', //请求失败
								type: 'error'
							});
						});
				
				},
				// 触发搜索按钮
				handleSearch() {
					this.$set(this.query, 'pageIndex', 1);
				
					this.getData(1);
					this.get_SAA_List_Count(); //获取当前列表条数
					sessionStorage.setItem('bookSAApage',1);
				},
				handleAdd() {
					this.$router.push('/addBookSAA'); // 跳转路由

				},
				// 编辑操作
				handleEdit(index, row) {

					
					this.idx = index;
					let that=this;
					// 跳转路由
					this.$router.push({
						name: 'editBookSAA',
						query: {
							SAAMSID: row.SAAMSID,
							// page:that.page
						}
					})

				},
				
				closeTags(index) {
					const delItem = this.COMM.tagsLists.splice(index, 1)[0];
					const item = this.COMM.tagsLists[index] ? this.COMM.tagsLists[index] : this.COMM.tagsLists[index - 1];
					if (item) {
						delItem.path === this.$route.fullPath && this.$router.push(item.path);
					} else {
						this.$router.push('/');
					}
				},
				
				// 编辑操作
				handleEditYCJE(index, row) {

					let that=this;
					// 跳转路由
					this.$router.push({
						name: 'editHBFY',
						query: {
							SAAMSID: row.SAAMSID,
							name:row.SAANAME,
							// page:that.page
						}
					})
				},
				// 分页导航 currentPage 改变时会触发
				handlePageChange(currentPage) {
					this.$set(this.query, 'pageIndex', currentPage);
					// 调取列表的函数，初始化时调一次
					this.getData(currentPage);
					sessionStorage.setItem('bookSAApage',currentPage);
				},
				//pageSize 改变时会触发
				handleSizeChange(size) {
					this.$set(this.query, 'pageIndex', 1);
					this.$set(this.query, 'pageSize', size);
					// 调取列表的函数，初始化时调一次
					this.getData(1);
					sessionStorage.setItem('bookSAApage',1);
				},
				
				getRowKeys(row) {
					return row.SAAMSID; // id为列表数据的唯一标识
				},
			}
			
}
</script>

<style scoped>
	.without-outline:focus {
	    outline: none;
	}
	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 12%;
	}


	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.black {
		color: #000000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}

	.select-shop {
		width: 16%;
	}

	.select-agent {
		width: 14%;
	}

	.el-row {
		margin-top: 15px;
	}

	.bg-purple {
		text-align: left;
	}

	.bg-purple-light {
		text-align: right;
	}

	.grid-content {
		min-height: 34px;
	}

	.handle-input {
		width: 250px;
	}

	.el-input--small .el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
	}

	.el-upload--text {
		width: 140px;
		height: 80px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 140px;
		height: 80px;
		line-height: 80px;
		text-align: center;
	}

	.avatar {
		width: 140px;
		height: 80px;
		display: block;
	}

	.el-dialog__footer {
		text-align: center;
	}

	.dialog-footer-btn {
		margin-right: 20px;
	}

	.cropper {
		width: auto;
		height: 300px;
	}
</style>
